import { useGetTranslationGroup, useUpdateTranslation } from '@/state/translations';
import { useFormContext } from 'react-hook-form';
import { TranslationGroupProofreadFormData } from '../state/types';
import { useCurrentDraftGroupId } from './useCurrentDraftGroupId';

export function useSubmitTranslationDrafts() {
    const groupId = useCurrentDraftGroupId();
    const { data: groupData } = useGetTranslationGroup(groupId!);
    const { mutateAsync: updateTranslation } = useUpdateTranslation();
    const { handleSubmit, formState, getFieldState } = useFormContext<TranslationGroupProofreadFormData>();

    async function onSubmit({ selectedVoiceId, captionsByTranslationId }: TranslationGroupProofreadFormData) {
        await Promise.all(
            (groupData?.translations || []).map(({ id }) => {
                const { isDirty: sentencesDirty } = getFieldState(`captionsByTranslationId.${id}.sentences`, formState);
                const { isDirty: voiceDirty } = getFieldState('selectedVoiceId', formState);

                const updatedSentences = captionsByTranslationId?.[id]?.sentences;

                if (!sentencesDirty && !voiceDirty) {
                    return Promise.resolve();
                }
                return updateTranslation({
                    id,
                    ...(voiceDirty && { voice_id: selectedVoiceId || '' }),
                    ...(sentencesDirty && { sentences: updatedSentences }),
                });
            })
        );
    }

    return {
        submitTranslationDrafts: handleSubmit(onSubmit),
    };
}
